import React from "react";
import GraphViewer from "../GraphPlotter/GraphViewer";

// Common coordinate-plane presentation for systems in original papers and variants.
export default function LinearSystemGraph({lines,xRange=[-4,5],yRange=[-4,6],label="Wykres układu równań",height=340}) {
  return <div role="img" aria-label={label} style={{margin:"16px auto",maxWidth:420}}>
    <GraphViewer equations={lines.map(({slope,intercept})=>({expr:`y=(${slope})*x+(${intercept})`,width:3}))}
      xRange={xRange} yRange={yRange} height={height} width={420}
      preserveSquare squareFrame={false} mathLabels showGrid yTickStep={1}/>
  </div>;
}
